import React, { useEffect } from "react";
import "../static/artists.css";
export default function ArtistsList({ artists }) {
  function truncateBio(str, n, useWordBoundary) {
    if (str.length <= n) {
      return str;
    }
    const subString = str.substr(0, n - 1); // the original check
    return (
      (useWordBoundary
        ? subString.substr(0, subString.lastIndexOf(" "))
        : subString) + "..."
    );
  }

  const generateOmbreLiveLink = (artistHandle) =>
    `${process.env.REACT_APP_WEB_BASE_URL}/${artistHandle}`;

  return (
    <div>
      <div className="container-fluid d-flex flex-row overflow-auto artistContainer eventsContainer  pt-xl-3 pt-lg-3 pt-md-3 pt-sm-2 pt-2 pl-xl-7 pl-lg-5 pl-md-5 pl-sm-0 pl-0">
        {artists.map((artist) => {
          return (
            <div className="mr-xl-5 mr-lg-5 mr-md-5 mr-sm-2 mr-2">
              <a href={generateOmbreLiveLink(artist.handle)}>
                <div className="row flex-column justify-content-center ">
                  <div className="artistImageContainer overflow-hidden rounded-circle ml-xl-0 ml-lg-0 ml-md-0  mt-xl-3 mt-lg-3 mt-md-3 ml-sm-4 ml-4 mt-sm-3 mt-3 mb-xl-2 mb-lg-2 mb-md-2">
                    <img className="artistImage" src={artist.displayPicture} />
                  </div>

                  <div className="curatedDescription ml-xl-0 ml-lg-0 ml-md-0  ml-sm-4 ml-4  artistName  text-center pt-xl-3 pt-lg-3 pt-md-3 pt-sm-3 pt-3 pb-xl-2 pb-lg-2 pb-md-2">
                    {artist.name}
                  </div>
                  <div className="d-none d-xl-block d-lg-block d-md-block text-center m-auto">
                    <div className="artistBio truncate-overflow col-xl-12 px-0 ">
                      {truncateBio(artist.bio, 32)}
                    </div>
                  </div>
                </div>
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/ArtistsList.jsx